import * as React from "react";
import { forwardRef, memo } from "react";
const SvgArrowsUpDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 1V17M15 17L11 13M15 17L19 13M5 17V1M5 1L1 5M5 1L9 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowsUpDown);
const Memo = memo(ForwardRef);
export default Memo;
